import { Label } from '@/components/ui/label'
import { cn } from '@/lib/utils'

export type OdinFormLabelProps = {
  htmlFor?: string
  required?: boolean
  children: React.ReactNode
  className?: string
}

export function OdinFormLabel({ htmlFor, required, children, className }: OdinFormLabelProps) {
  return (
    <Label htmlFor={htmlFor} className={cn('text-sm leading-6 font-semibold', className)}>
      <span>
        {children}
        {required && <span className="ml-0.5 text-destructive">*</span>}
      </span>
    </Label>
  )
}
